export default function themeTypography() {
  return {
    fontFamily: 'inherit',
    body1: {
      fontSize: '14px'
    }
  };
}